import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Create")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_SingleOrgPicker = _resolveComponent("SingleOrgPicker")
  const _component_el_form = _resolveComponent("el-form")
  const _directive_loading = _resolveDirective("loading")

  return _withDirectives((_openBlock(), _createBlock("div", null, [
    (_ctx.isEditing)
      ? (_openBlock(), _createBlock("h1", _hoisted_1, _toDisplayString(_ctx.editableWorkflow?.title), 1))
      : (_openBlock(), _createBlock("h1", _hoisted_2, "Create workflow")),
    _createVNode(_component_el_button, {
      type: "info",
      icon: "el-icon-arrow-left",
      onClick: _ctx.routeBack
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_el_form, { model: _ctx.editableWorkflow }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "Title" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "text",
              modelValue: _ctx.editableWorkflow.title,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.editableWorkflow.title = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.isSuperAdmin || _ctx.isVAR)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "Organization"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SingleOrgPicker, {
                  modelValue: _ctx.editableWorkflow.org,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.editableWorkflow.org = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, { label: "Event" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "text",
              modelValue: _ctx.editableWorkflow.event,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.editableWorkflow.event = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "Code Block" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "textarea",
              modelValue: _ctx.editableWorkflow.code_block,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.editableWorkflow.code_block = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            (_ctx.isEditing)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  onClick: _ctx.updateWorkflow,
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  onClick: _ctx.createWorkflow,
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["onClick"]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ], 512)), [
    [_directive_loading, _ctx.fetchState === _ctx.FetchStates.FETCHING]
  ])
}